const questions = [
  {
    id: 1,
    title: "Why do you want to be a developer?",
    info: "There is a greater freedom and creativy with computer development once you've assembled your toolbelt. I choose my career prospects with the intent to help improve the lives of those around me, and this is the next step in that journey.",
  },
  {
    id: 2,
    title: "Where are you from?",
    info: "I was born and raised in Southern California, but living in Indiana since high school. I've seen all 50 states and several other countries with the goal of seeing as many as possible!",
  },
  {
    id: 3,
    title: "Why did you leave physical therapy?",
    info: "I didn't! I still use the tools I learned during my years as a physical therapist every day. You'd be surprised how many skills are useful in the development field.",
  },
  {
    id: 4,
    title: "What is the best kind of wine?",
    info: "Naturally that depends on who you ask, where you live, and the weather. When not pairing with food, my favorite is a very dry red UNLESS it's a lovely summer day, then a chilled Gewürztraminer can't be beat.",
  },
  {
    id: 5,
    title: "Are we alone in the universe?",
    info: "Whoa, now. That's a pretty deep question. Considering how unfathomably vast the universe is, it's folly to think we're alone. I mean, we have barely explored our own oceans yet, let alone the universe!",
  },
  {
    id: 6,
    title: "What if I want to ask a specific question?",
    info: "Please send me an email from my portfolio website: www.timmalone.dev using the email address listed at the bottom of every page. I look forward to hearing from you!",
  },
];

export default questions;
